export default __webpack_public_path__ + "static/media/into.9bb951e6.png";